// extracted by mini-css-extract-plugin
export var locationCard = "_rc-0";